export default function getMeasureMappings(): any {
  return {
    HK034: [
      {
        name: 'HK034//HK034.FIQ01_X',
        DeviceId: 'HK034',
        quality: 'm3/h',
        description: 'HK034 Glykolipumppaamo ylivuotovirtaus',
        active: false
      },
      {
        name: 'HK034//HK034.FIQ02_X',
        DeviceId: 'HK034',
        quality: 'm3/h',
        description: 'HK034 Glykolipumppaamo pumput 2 ja 3 virtausmittaus',
        active: false
      },
      {
        name: 'HK034//HK034.FIQ03_X',
        DeviceId: 'HK034',
        quality: 'm3/h',
        description: 'HK034 Glykolipumppaamo pumppu 1 virtausmittaus',
        active: false
      },
      {
        name: 'HK034//HK034.FIQ04_X',
        DeviceId: 'HK034',
        quality: 'm3/h',
        description: 'HK034 Glykolipumppaamo glykoliviemäri virtausmittaus',
        active: false
      },
      {
        name: 'HK034//HK034.FIQ05_X',
        DeviceId: 'HK034',
        quality: 'm3/h',
        description: 'Asemataso T1 Glykoliviemärin virtausmittaus',
        active: false
      },
      {
        name: 'HK034//HK034.LIA01_X',
        DeviceId: 'HK034',
        quality: 'cm',
        description: 'HK034 Glykolipumppaamo imualtaan pintamittaus',
        active: false
      },
      {
        name: 'HK034//HK034.LIA02_X',
        DeviceId: 'HK034',
        quality: 'cm',
        description: 'HK034 Glykolipumppaamo varastotunnelin pintamittaus',
        active: false
      },
      {
        name: 'HK034//HK034.PI01_X',
        DeviceId: 'HK034',
        quality: 'bar',
        description: 'HK034 Glykolipumppaamo glykoliviemärin painemittaus',
        active: false
      },
      {
        name: 'HK034//HK034.QTI_X',
        DeviceId: 'HK034',
        quality: 'mg/l',
        description: 'HK034 Glykolipumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK034//HK034.TE02_X',
        DeviceId: 'HK034',
        quality: '⁰C',
        description: 'HK034 Glykolipumppaamo huonelämpötilamittaus',
        active: false
      }
    ],
    HK123: [
      {
        name: 'HK123//HK123.FIQ01_X',
        DeviceId: 'HK123',
        quality: 'm3/h',
        description: 'HK123 Tasausallas virtausmittaus',
        active: false
      },
      {
        name: 'HK123//HK123.FIQ02_X',
        DeviceId: 'HK123',
        quality: 'm3/h',
        description: 'HK123 Tasausallas ylivuodon virtausmittaus',
        active: false
      },
      {
        name: 'HK123//HK123.LIA01_X',
        DeviceId: 'HK123',
        quality: 'cm',
        description: 'HK123 Tasausallas pintamittaus',
        active: false
      },
      {
        name: 'HK123_LI2_X',
        DeviceId: 'HK123',
        quality: 'cm',
        description: 'HK123 tasausallas mittarikaivo pintamittaus',
        active: false
      },
      {
        name: 'HK123_PU1_HZ_X',
        DeviceId: 'HK123',
        quality: 'Hz',
        description: 'HK123 tasausallas pumppu1 TJM Hz-mittaus',
        active: false
      },
      {
        name: 'HK123_PU2_HZ_X',
        DeviceId: 'HK123',
        quality: 'Hz',
        description: 'HK123 tasausallas pumppu2 TJM Hz-mittaus',
        active: false
      }
    ],
    HK124: [
      {
        name: 'HK123//HK124.FIQ01_X',
        DeviceId: 'HK124',
        quality: 'm3/h',
        description: 'HK124 tyhjennysallas pumpattu vesi virtausmittaus',
        active: false
      },
      {
        name: 'HK123//HK124.FIQ02_X',
        DeviceId: 'HK124',
        quality: 'm3/h',
        description: 'HK124 tyhjennysallas imetty vesi virtausmittaus',
        active: false
      },
      {
        name: 'HK123//HK124.LISA01_X',
        DeviceId: 'HK124',
        quality: 'cm',
        description: 'HK124 tyhjennysallas pintamittaus',
        active: false
      },
      {
        name: 'HK124_LIA02_X',
        DeviceId: 'HK124',
        quality: 'cm',
        description: 'HK124 tuloallas pintamittaus',
        active: false
      }
    ],
    HK143: [
      {
        name: 'HK133//HK143.LIA01_X',
        DeviceId: 'HK143',
        quality: 'cm',
        description: 'HK143 Suojakaivo1 pintamittaus',
        active: false
      }
    ],
    HK144: [
      {
        name: 'HK133//HK144.LIA01_X',
        DeviceId: 'HK144',
        quality: 'cm',
        description: 'HK144 Suojakaivo2 pintamittaus',
        active: false
      }
    ],
    HK182: [
      {
        name: 'HK521//HK182.LIA01_X',
        DeviceId: 'HK182',
        quality: 'cm',
        description: 'HK518 Glykolivesiallas pintamittaus',
        active: false
      },
      {
        name: 'HK521//HK182.LIA02_X',
        DeviceId: 'HK182',
        quality: 'cm',
        description: 'Purkukaivo 61 pintamittaus',
        active: false
      }
    ],
    HK503: [
      {
        name: 'HK133//HK503.LIA01_X',
        DeviceId: 'HK503',
        quality: 'cm',
        description: 'HK503 Ilmastuspumppaamo pintamittaus',
        active: false
      }
    ],
    HK504: [
      {
        name: 'HK133//HK504.LIA01_X',
        DeviceId: 'HK504',
        quality: 'cm',
        description: 'HK504 Ilmastuspumppaamo pintamittaus',
        active: false
      }
    ],
    HK505: [
      {
        name: 'HK133//HK505.FIQ01_X',
        DeviceId: 'HK505',
        quality: 'm3/h',
        description: 'HK505 Ilmastuspumppaamo virtausmittaus',
        active: false
      },
      {
        name: 'HK133//HK505.LIA01_X',
        DeviceId: 'HK505',
        quality: 'cm',
        description: 'HK505 Ilmastuspumppaamo pintamittaus',
        active: false
      }
    ],
    HK509: [
      {
        name: 'HK034//HK509.FIQ01_X',
        DeviceId: 'HK509',
        quality: 'm3/h',
        description: 'HK509 pumppaamo tuloveden virtausmittaus',
        active: false
      },
      {
        name: 'HK034//HK509.FIQ02_X',
        DeviceId: 'HK509',
        quality: 'm3/h',
        description: 'HK509 pumppaamo ylivuoto virtausmittaus',
        active: false
      },
      {
        name: 'HK034//HK509.QTI_X',
        DeviceId: 'HK509',
        quality: 'mg/l',
        description: 'HK509 pumppaamo tuloveden glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK034//HK509.TE01_X',
        DeviceId: 'HK509',
        quality: '⁰C',
        description: 'HK509 pumppaamo tuloveden lämpötilamittaus',
        active: false
      }
    ],
    HK512: [
      {
        name: 'HK512//HK512.FIQ01_2_YHT_X',
        DeviceId: 'HK512',
        quality: 'm3/h',
        description: 'HK512 Mittakaivo Glykoliveden virtaus yhteensä',
        active: false
      },
      {
        name: 'HK512//HK512.FIQ01_X',
        DeviceId: 'HK512',
        quality: 'm3/h',
        description: 'HK512 Mittakaivo Glykoliveden virtausmittaus',
        active: false
      },
      {
        name: 'HK512//HK512.FIQ02_X',
        DeviceId: 'HK512',
        quality: 'm3/h',
        description: 'HK512 Mittakaivo Glykoliveden virtausmittaus',
        active: false
      },
      {
        name: 'HK512//HK512.FIQ03_X',
        DeviceId: 'HK512',
        quality: 'm3/h',
        description: 'HK512 Mittakaivo ylivuodon virtausmittaus',
        active: false
      },
      {
        name: 'HK512//HK512.LIA01_X',
        DeviceId: 'HK512',
        quality: 'cm',
        description: 'HK512 Mittakaivo jakokaivon pinnankorkeusmittaus',
        active: false
      },
      {
        name: 'HK512//HK512.QTI_X',
        DeviceId: 'HK512',
        quality: 'mg/l',
        description: 'HK512 Mittakaivo jakokaivon glykolipitoisuusmittaus',
        active: false
      }
    ],
    HK515: [
      {
        name: 'HK521//HK515.LIA01_X',
        DeviceId: 'HK515',
        quality: 'cm',
        description: 'HK515 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK521//HK515.QTI01_X',
        DeviceId: 'HK515',
        quality: 'mg/l',
        description: 'HK515 pumppaamo Glykolipitoisuusmittaus (kaivon mittari)',
        active: false
      },
      {
        name: 'HK521//HK515.QTI02_X',
        DeviceId: 'HK515',
        quality: 'mg/l',
        description: 'HK515 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK521//HK515QTI02_N.X_AL',
        DeviceId: 'HK515',
        quality: 'mg/l',
        description: 'HK515 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK516: [
      {
        name: 'HK521//HK516.LIA01_X',
        DeviceId: 'HK516',
        quality: 'cm',
        description: 'HK516 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK521//HK516.QTI01_X',
        DeviceId: 'HK516',
        quality: 'mg/l',
        description: 'HK516 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK521//HK516.QTI02_X',
        DeviceId: 'HK516',
        quality: 'mg/l',
        description: 'HK516 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK521//HK516QTI02_N.X_AL',
        DeviceId: 'HK516',
        quality: 'mg/l',
        description: 'HK516 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK517: [
      {
        name: 'HK521//HK517.LIA01_X',
        DeviceId: 'HK517',
        quality: 'cm',
        description: 'HK517 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK521//HK517.QTI01_X',
        DeviceId: 'HK517',
        quality: 'mg/l',
        description: 'HK517 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK521//HK517.QTI02_X',
        DeviceId: 'HK517',
        quality: 'mg/l',
        description: 'HK517 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK521//HK517QTI02_N.X_AL',
        DeviceId: 'HK517',
        quality: 'mg/l',
        description: 'HK517 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK518: [
      {
        name: 'HK521//HK518.LIA01_X',
        DeviceId: 'HK518',
        quality: 'cm',
        description: 'HK518 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK521//HK518.QTI01_X',
        DeviceId: 'HK518',
        quality: 'mg/l',
        description: 'HK518 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK521//HK518.QTI02_X',
        DeviceId: 'HK518',
        quality: 'mg/l',
        description: 'HK518 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK521//HK518QTI02_N.X_AL',
        DeviceId: 'HK518',
        quality: 'mg/l',
        description: 'HK518 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK519: [
      {
        name: 'HK521//HK519.LIA01_X',
        DeviceId: 'HK519',
        quality: 'cm',
        description: 'HK519 tasausallas pintamittaus',
        active: false
      }
    ],
    HK520: [
      {
        name: 'HK521//HK520.FIQ01_X',
        DeviceId: 'HK520',
        quality: 'm3/h',
        description: 'HK520 pumppaamo glykoliviemärin virtausmittaus',
        active: false
      },
      {
        name: 'HK521//HK520.FIQ02_X',
        DeviceId: 'HK520',
        quality: 'm3/h',
        description: 'HK520 pumppaamo väkevä glykolivesi virtausmittaus',
        active: false
      },
      {
        name: 'HK521//HK520.LIA01_X',
        DeviceId: 'HK520',
        quality: 'cm',
        description: 'HK520 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK521//HK520.QTI02_X',
        DeviceId: 'HK520',
        quality: 'mg/l',
        description: 'HK520 pumppaamo Glykolipit. mittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK521//HK520QTI02_N.X_AL',
        DeviceId: 'HK520',
        quality: 'mg/l',
        description: 'HK520 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK521: [
      {
        name: 'HK521//HK521.LIA01_X',
        DeviceId: 'HK521',
        quality: 'cm',
        description: 'Venttiilikaivo 68 pinnanmittaus',
        active: false
      },
      {
        name: 'HK521//HK521.QTI02_X',
        DeviceId: 'HK521',
        quality: 'mg/l',
        description: 'Venttiilikaivo 68 Glykolipit. mittaus(TOC/ Laitetilan analysaattori)',
        active: false
      }
    ],
    HK522: [
      {
        name: 'HK133//HK522.FIQ01_X',
        DeviceId: 'HK522',
        quality: 'm3/h',
        description: 'HK522 Mittakaivo 3000 Virtaama',
        active: false
      }
    ],
    HK523: [
      {
        name: 'HK133//HK523.FIQ01_X',
        DeviceId: 'HK523',
        quality: 'm3/h',
        description: 'HK523 Mittakaivo 2997 Virtaama',
        active: false
      }
    ],
    HK524: [
      {
        name: 'HK133//HK524.FIQ01_X',
        DeviceId: 'HK524',
        quality: 'm3/h',
        description: 'HK524 Mittakaivo 241 Virtaama',
        active: false
      },
      {
        name: 'HK133//HK524.FIQ02_X',
        DeviceId: 'HK524',
        quality: 'm3/h',
        description: 'HK524 Mittakaivo 248 Virtaama',
        active: false
      }
    ],
    HK525: [
      {
        name: 'HK525_LIA01_X',
        DeviceId: 'HK525',
        quality: 'cm',
        description: 'HK525 keräilyallas pintamittaus',
        active: false
      }
    ],
    HK526: [
      {
        name: 'HK533//HK526.FIQ01_X',
        DeviceId: 'HK526',
        quality: 'm3/h',
        description: 'HK526 pumppaamo glykoliveden virtausmittaus',
        active: false
      },
      {
        name: 'HK533//HK526.QTI02_X',
        DeviceId: 'HK526',
        quality: 'mg/l',
        description: 'HK526 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK526QTI02_N.X_AL',
        DeviceId: 'HK526',
        quality: 'mg/l',
        description: 'HK526 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK527: [
      {
        name: 'HK533//HK527.LIA01_X',
        DeviceId: 'HK527',
        quality: 'cm',
        description: 'HK527 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK533//HK527.QTI01_X',
        DeviceId: 'HK527',
        quality: 'mg/l',
        description: 'HK527 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK533//HK527.QTI02_X',
        DeviceId: 'HK527',
        quality: 'mg/l',
        description: 'HK527 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK527QTI02_N.X_AL',
        DeviceId: 'HK527',
        quality: 'mg/l',
        description: 'HK527 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK528: [
      {
        name: 'HK533//HK528.LIA01_X',
        DeviceId: 'HK528',
        quality: 'cm',
        description: 'HK528 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK533//HK528.QTI01_X',
        DeviceId: 'HK528',
        quality: 'mg/l',
        description: 'HK528 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK533//HK528.QTI02_X',
        DeviceId: 'HK528',
        quality: 'mg/l',
        description: 'HK528 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK528QTI02_N.X_AL',
        DeviceId: 'HK528',
        quality: 'mg/l',
        description: 'HK528 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK529: [
      {
        name: 'HK533//HK529.LIA01_X',
        DeviceId: 'HK529',
        quality: 'cm',
        description: 'HK529 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK533//HK529.QTI01_X',
        DeviceId: 'HK529',
        quality: 'mg/l',
        description: 'HK529 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK533//HK529.QTI02_X',
        DeviceId: 'HK529',
        quality: 'mg/l',
        description: 'HK529 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK529QTI02_N.X_AL',
        DeviceId: 'HK529',
        quality: 'mg/l',
        description: 'HK529 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK530: [
      {
        name: 'HK533//HK530.LIA01_X',
        DeviceId: 'HK530',
        quality: 'cm',
        description: 'HK530 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK533//HK530.QTI01_X',
        DeviceId: 'HK530',
        quality: 'mg/l',
        description: 'HK530 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK533//HK530.QTI02_X',
        DeviceId: 'HK530',
        quality: 'mg/l',
        description: 'HK530 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK530QTI02_N.X_AL',
        DeviceId: 'HK530',
        quality: 'mg/l',
        description: 'HK530 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK531: [
      {
        name: 'HK533//HK531.LIA01_X',
        DeviceId: 'HK531',
        quality: 'cm',
        description: 'HK531 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK533//HK531.QTI01_X',
        DeviceId: 'HK531',
        quality: 'mg/l',
        description: 'HK531 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK533//HK531.QTI02_X',
        DeviceId: 'HK531',
        quality: 'mg/l',
        description: 'HK531 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK531QTI02_N.X_AL',
        DeviceId: 'HK531',
        quality: 'mg/l',
        description: 'HK531 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK532: [
      {
        name: 'HK533//HK532.LIA01_X',
        DeviceId: 'HK532',
        quality: 'cm',
        description: 'HK532 pumppaamo pintamittaus',
        active: false
      },
      {
        name: 'HK533//HK532.QTI01_X',
        DeviceId: 'HK532',
        quality: 'mg/l',
        description: 'HK532 pumppaamo Glykolipitoisuusmittaus',
        active: false
      },
      {
        name: 'HK533//HK532.QTI02_X',
        DeviceId: 'HK532',
        quality: 'mg/l',
        description: 'HK532 pumppaamo Glykolipitoisuusmittaus (TOC/ Laitetilan analysaattori)',
        active: false
      },
      {
        name: 'HK533//HK532QTI04_N_V.X_AL',
        DeviceId: 'HK532',
        quality: 'mg/l',
        description: 'HK532 pumppaamo glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ],
    HK533: [
      {
        name: 'HK533//HK533.FIQ01_X',
        DeviceId: 'HK533',
        quality: 'm3/h',
        description: 'Mittarikaivo MK04R-JP väkevän glykoliveden virtausmittaus',
        active: false
      },
      {
        name: 'HK533//HK533.FIQ02_X',
        DeviceId: 'HK533',
        quality: 'm3/h',
        description: 'Mittarikaivo KV3 sadevesiviemärin virtausmittaus',
        active: false
      }
    ],
    HK539: [
      {
        name: 'HK539_LIA01_X',
        DeviceId: 'HK539',
        quality: 'cm',
        description: 'HK539 Suojapumppaamo pintamittaus',
        active: false
      }
    ],
    HK544: [
      {
        name: 'HK544_FISR1_2_LASK_X',
        DeviceId: 'HK544',
        quality: 'm3/h',
        description: 'HK544 Glykolivesipumppaamo lähtevä vesi virtaus yhteensä (log. laskee)',
        active: false
      },
      {
        name: 'HK544_FISR1_X',
        DeviceId: 'HK544',
        quality: 'm3/h',
        description: 'HK544 Glykolivesipumppaamo lähtevä vesi virtaus pumppu M1',
        active: false
      },
      {
        name: 'HK544_FISR2_X',
        DeviceId: 'HK544',
        quality: 'm3/h',
        description: 'HK544 Glykolivesipumppaamo lähtevä vesi virtaus pumppu M2',
        active: false
      },
      {
        name: 'HK544_LISRA1_X',
        DeviceId: 'HK544',
        quality: 'cm',
        description: 'HK544 Glykolivesipumppaamo Hiekanerotusaltaan pinta LISRA1',
        active: false
      },
      {
        name: 'HK544_LISRA2_X',
        DeviceId: 'HK544',
        quality: 'cm',
        description: 'HK544 Glykolivesipumppaamo imualtaan pinta LISRA2',
        active: false
      },
      {
        name: 'HK544_LISRA3_X',
        DeviceId: 'HK544',
        quality: 'cm',
        description: 'HK544 Glykolivesipumppaamo ohituskaivon pinta LISRA3',
        active: false
      },
      {
        name: 'HK544_M1_HZ_X',
        DeviceId: 'HK544',
        quality: 'Hz',
        description: 'HK544 Glykolivesipumppaamo Glykolivesipumppu 1 HZ-mittaus',
        active: false
      },
      {
        name: 'HK544_M1_I_X',
        DeviceId: 'HK544',
        quality: 'm3/h',
        description: 'HK544 Glykolivesipumppaamo Glykolivesipumppu 1 virtamittaus',
        active: false
      },
      {
        name: 'HK544_M2_HZ_X',
        DeviceId: 'HK544',
        quality: 'Hz',
        description: 'HK544 Glykolivesipumppaamo Glykolivesipumppu 2 HZ-mittaus',
        active: false
      },
      {
        name: 'HK544_M2_I_X',
        DeviceId: 'HK544',
        quality: 'm3/h',
        description: 'HK544 Glykolivesipumppaamo Glykolivesipumppu 2 virtamittaus',
        active: false
      },
      {
        name: 'HK544_QTI3_1_X',
        DeviceId: 'HK544',
        quality: 'mg/l',
        description: 'HK544 Glykolivesipumppaamo Hiekanerotusallas TOC-pitoisuus (linja1)',
        active: false
      },
      {
        name: 'HK544_QTI3_2_X',
        DeviceId: 'HK544',
        quality: 'mg/l',
        description: 'HK544 Glykolivesipumppaamo imualtaan TOC-pitoisuus (linja2)',
        active: false
      },
      {
        name: 'HK544_QTI3_3_X',
        DeviceId: 'HK544',
        quality: 'mg/l',
        description: 'HK544 Glykolivesipumppaamo ohituskaivon TOC-pitoisuus (linja3)',
        active: false
      }
    ],
    HK546: [
      {
        name: 'HK546_LI01_X',
        DeviceId: 'HK546',
        quality: 'cm',
        description: 'HK546 Tulokaivo 1 pinnankorkeus mittaus',
        active: false
      },
      {
        name: 'HK546_LI02_X',
        DeviceId: 'HK546',
        quality: 'cm',
        description: 'HK546 Tulokaivo 2 pinnankorkeus mittaus',
        active: false
      },
      {
        name: 'HK546_LI03_X',
        DeviceId: 'HK546',
        quality: 'cm',
        description: 'HK546 Tulokaivo 3 pinnankorkeus mittaus',
        active: false
      },
      {
        name: 'HK546_QTI01_X',
        DeviceId: 'HK546',
        quality: 'mg/l',
        description: 'HK546 Tulokaivo 1 Glykolipitoisuuden (mg/l) mittaus',
        active: false
      },
      {
        name: 'HK546_QTI02_X',
        DeviceId: 'HK546',
        quality: 'mg/l',
        description: 'HK546 Tulokaivo 2 Glykolipitoisuuden (mg/l) mittaus',
        active: false
      },
      {
        name: 'HK546_QTI03_X',
        DeviceId: 'HK546',
        quality: 'mg/l',
        description: 'HK546 Tulokaivo 3 Glykolipitoisuuden (mg/l) mittaus',
        active: false
      }
    ],
    HK547: [
      {
        name: 'HK525_HK547_QTI1_X',
        DeviceId: 'HK547',
        quality: 'mg/l',
        description: 'HK547 Glykolipitoisuus (%) mittaus',
        active: false
      },
      {
        name: 'HK547_LIA01_X',
        DeviceId: 'HK547',
        quality: 'cm',
        description: 'HK547 Jakokaivo pintamittaus',
        active: false
      }
    ],
    HK548: [
      {
        name: 'HK548_LIA01_X',
        DeviceId: 'HK548',
        quality: 'cm',
        description: 'HK548 Suojapumppaamo pintamittaus',
        active: false
      }
    ],
    HK732: [
      {
        name: 'HK525_HK732_QTI1_X',
        DeviceId: 'HK732',
        quality: 'mg/l',
        description: 'HK732 Glykolipitoisuus (%) mittaus',
        active: false
      },
      {
        name: 'HK732_LIA01_X',
        DeviceId: 'HK732',
        quality: 'cm',
        description: 'HK732 Jakokaivo pintamittaus',
        active: false
      }
    ],
    HK742: [
      {
        name: 'HK525_HK742_QTI1_X',
        DeviceId: 'HK742',
        quality: 'mg/l',
        description: 'HK742 Glykolipitoisuus (%) mittaus',
        active: false
      },
      {
        name: 'HK742LIA01_X',
        DeviceId: 'HK742',
        quality: 'cm',
        description: 'HK742 Jakokaivo pintamittaus',
        active: false
      }
    ],
    HK775: [
      {
        name: 'HK525_HK775_QTI1_X',
        DeviceId: 'HK775',
        quality: 'mg/l',
        description: 'HK775 Glykolipitoisuus (%) mittaus',
        active: false
      },
      {
        name: 'HK775_LIA01_X',
        DeviceId: 'HK775',
        quality: 'cm',
        description: 'HK775 Jakokaivo pintamittaus',
        active: false
      }
    ],
    K68: [
      {
        name: 'HK521//K68QTI02_N.X_AL',
        DeviceId: 'K68',
        quality: 'mg/l',
        description: 'Kaivo 68 glykolinäytemitttauksen arvo aikaleiman kohdalla',
        active: false
      }
    ]
  };
}
